// This file is generated by assets/update.ts - DO NOT EDIT MANUALLY
// Run 'bun assets/update.ts' to regenerate this file

import { resolveDefaultParserAsset } from "#opentui/runtime-assets"

import type { FiletypeParserOptions, InjectionMapping } from "./types.js"

interface DefaultParserDescriptor {
  readonly filetype: string
  readonly aliases?: readonly string[]
  readonly queries: {
    readonly highlights: readonly string[]
    readonly injections?: readonly string[]
  }
  readonly wasm: string
  readonly injectionMapping?: InjectionMapping
}

const defaultParserDescriptors: readonly DefaultParserDescriptor[] = [
  {
    "filetype": "javascript",
    "aliases": ["javascriptreact"],
    "queries": { "highlights": ["assets/javascript/highlights.scm"] },
    "wasm": "assets/javascript/tree-sitter-javascript.wasm"
  },
  {
    "filetype": "typescript",
    "aliases": ["typescriptreact"],
    "queries": { "highlights": ["assets/typescript/highlights.scm"] },
    "wasm": "assets/typescript/tree-sitter-typescript.wasm"
  },
  {
    "filetype": "markdown",
    "queries": {
      "highlights": ["assets/markdown/highlights.scm"],
      "injections": ["assets/markdown/injections.scm"]
    },
    "wasm": "assets/markdown/tree-sitter-markdown.wasm",
    "injectionMapping": {
      "nodeTypes": { "inline": "markdown_inline", "pipe_table_cell": "markdown_inline" },
      "infoStringMap": {
        "javascript": "javascript",
        "js": "javascript",
        "jsx": "javascriptreact",
        "javascriptreact": "javascriptreact",
        "typescript": "typescript",
        "ts": "typescript",
        "tsx": "typescriptreact",
        "typescriptreact": "typescriptreact",
        "markdown": "markdown",
        "md": "markdown"
      }
    }
  },
  {
    "filetype": "markdown_inline",
    "queries": { "highlights": ["assets/markdown_inline/highlights.scm"] },
    "wasm": "assets/markdown_inline/tree-sitter-markdown_inline.wasm"
  },
  {
    "filetype": "zig",
    "queries": { "highlights": ["assets/zig/highlights.scm"] },
    "wasm": "assets/zig/tree-sitter-zig.wasm"
  }
]

export const defaultParserAssetPaths: readonly string[] = [
  ...new Set(
    defaultParserDescriptors.flatMap((parser) => [
      ...parser.queries.highlights,
      parser.wasm,
      ...(parser.queries.injections ?? []),
    ]),
  ),
]

let cachedParsers: Promise<FiletypeParserOptions[]> | undefined

export function getParsers(): Promise<FiletypeParserOptions[]> {
  cachedParsers ??= Promise.all(defaultParserDescriptors.map(resolveDefaultParser))
  return cachedParsers
}

async function resolveDefaultParser(parser: DefaultParserDescriptor): Promise<FiletypeParserOptions> {
  const queries: FiletypeParserOptions["queries"] = {
    highlights: await Promise.all(parser.queries.highlights.map(resolveParserAsset)),
  }
  if (parser.queries.injections) {
    queries.injections = await Promise.all(parser.queries.injections.map(resolveParserAsset))
  }

  return {
    filetype: parser.filetype,
    ...(parser.aliases ? { aliases: [...parser.aliases] } : {}),
    queries,
    wasm: await resolveParserAsset(parser.wasm),
    ...(parser.injectionMapping ? { injectionMapping: parser.injectionMapping } : {}),
  }
}

function resolveParserAsset(relativePath: string): Promise<string> {
  return resolveDefaultParserAsset(relativePath, new URL(`./${relativePath}`, import.meta.url))
}
